export default {
  tablet: 768,
  tabletLarge: 992,
  laptop: 1024,
  desktop: 1440,
  desktopLarge: 1920,
};
